<template>
  <div class="layout" :class="{ is_navbar: is_navbar }">
    <lay-heads v-if="is_navbar" class="v-heads w100" />
    <Mains />
  </div>
</template>

<script>
import Mains from "./component/main.vue";
import "./export.js";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Layout",
  components: { Mains },
  data() {
    return {};
  },
  computed: {
    is_navbar() {
      if (
        this.$route.meta.is_navbar !== undefined &&
        this.$route.meta.is_navbar === false
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    console.log();
  },
};
</script>

<style scoped lang="scss">
.layout {
  height: 100vh;
  position: absolute;
  width: 100%;
  background-color: rgb(245 245 245);
  overflow-y: hidden;
  &.is_navbar {
    padding-top: 46px;
  }
  .v-heads {
    position: fixed;
    top: 0px;
    z-index: 99;
  }
}
</style>
